import { BenchmarkingRequestParams, BenchmarkingReportSettings } from '@/hooks'
import { DEFAULT_BENCHMARKING_REPORT_SETTINGS } from '@/utils/constants'

export const mapBenchmarkingParamsToReportSettings = (
    params: BenchmarkingRequestParams
): BenchmarkingReportSettings => {
    const reportSettings: BenchmarkingReportSettings = {
        display: params.type ?? DEFAULT_BENCHMARKING_REPORT_SETTINGS.display,
        basis:
            params.includeEmissions !== undefined
                ? params.includeEmissions
                    ? 'emission'
                    : 'usage'
                : DEFAULT_BENCHMARKING_REPORT_SETTINGS.basis,
        analysisType:
            params.trendType ??
            DEFAULT_BENCHMARKING_REPORT_SETTINGS.analysisType,
        applyWeatherNormalization:
            params.applyWeatherNormalization ??
            DEFAULT_BENCHMARKING_REPORT_SETTINGS.applyWeatherNormalization,
        applySquareFootage:
            params.applySquareFootage ??
            DEFAULT_BENCHMARKING_REPORT_SETTINGS.applySquareFootage,
        comparisonPeriod:
            params.trendType === 'trend'
                ? undefined
                : (params.comparisonPeriod ??
                  DEFAULT_BENCHMARKING_REPORT_SETTINGS.comparisonPeriod),
    }

    return reportSettings
}
